/** 앱별 기기 이미지 경로는 공유 AppConfig에서 관리합니다. */
import { getAppConfig, type AppId } from '@packages/types/app';
import { DeviceType } from '@packages/types/device/common/deviceTypes';
import {
  MiniSensorType,
  MINI_SENSOR_TYPE_INFO,
  MINI_SENSOR_TYPE_MAP,
} from '@packages/types/device/mini/sensors';

const defaultDevices = getAppConfig().devices;
export const LITE_IMAGE_WHOLE = defaultDevices[DeviceType.LITE].images.whole;
export const MINI_IMAGE_DISCONNECTED = defaultDevices[DeviceType.MINI].images.disconnected;
export const MINI_IMAGE_DEFAULT = defaultDevices[DeviceType.MINI].images.connected;

// 기존 로컬 연결 화면과의 호환용. 실제 경로는 공통 레지스트리에서 가져옵니다.
export const MINI_SENSOR_IMAGE_MAP = Object.fromEntries(
  Object.keys(MINI_SENSOR_TYPE_INFO).map(key => [
    Number(key),
    getDeviceImageUrl(DeviceType.MINI, {
      equippedSensor: Number(key),
      isConnected: true,
    }),
  ])
) as Record<MiniSensorType, string>;

export function getDeviceImageUrl(
  deviceType: string,
  opts: {
    appId?: AppId;
    equippedSensor?: number | null;
    sensorTypes?: string[] | null;
    isConnected: boolean;
  }
): string {
  const { equippedSensor, sensorTypes, isConnected, appId } = opts;
  const devices = getAppConfig(appId).devices;
  const images = (devices[deviceType as DeviceType] ?? devices[DeviceType.LITE]).images;
  if (!isConnected) return images.disconnected;
  if (deviceType !== DeviceType.MINI) return images.connected;
  const sensorType = equippedSensor ?? MINI_SENSOR_TYPE_MAP[sensorTypes?.[0] ?? ''];
  if (sensorType === MiniSensorType.NO_SENSOR) return images.disconnected;
  const sensorName =
    sensorType === MiniSensorType.O2_LF
      ? 'O2-LF'
      : MINI_SENSOR_TYPE_INFO[sensorType as MiniSensorType]?.label;
  return images.sensors?.[sensorName] ?? images.connected;
}
